import ActionType from "../ActionType";
const initAction = {
    type: ActionType.LOGIN_LOADING
};
export default initAction;